import mutations from './labHandleHistory.mutations'
import actions from './labHandleHistory.actions'
import getters from './labHandleHistory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
